import React, { useEffect, useState } from 'react';
import TrackingMap from '../../containers/Public/OrderTracking/components/TrackingMap';
import { cn } from '../../lib/utils';
import useTrackingOrder from './useTrackingOrder';
import { OrderRouteMapProps } from './OrderRouteMap.interface';
import '../../containers/Public/OrderTracking/order-tracking.css';

const OrderRouteMap: React.FC<OrderRouteMapProps> = ({
	order,
	mode,
	showPendingTrucks,
	className,
}) => {
	const tracking = useTrackingOrder(order, { mode, showPendingTrucks });
	const [selectedTruckId, setSelectedTruckId] = useState<number>();

	const singleTruckId =
		tracking?.trucks.length === 1 ? tracking.trucks[0].id : undefined;

	useEffect(() => {
		setSelectedTruckId(singleTruckId);
	}, [singleTruckId, order?.id]);

	const toggleTruck = (truckId: number) => {
		setSelectedTruckId((current) =>
			current === truckId ? undefined : truckId,
		);
	};

	return (
		<div
			className={cn(
				'relative w-full h-full overflow-hidden rounded-xl bg-track-map',
				className,
			)}
		>
			{tracking ? (
				<TrackingMap
					order={tracking}
					mode={mode}
					selectedTruckId={selectedTruckId}
					onSelectTruck={toggleTruck}
				/>
			) : null}
		</div>
	);
};

export default OrderRouteMap;
